import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import "./styles/main.css";
import "./styles/newUI.css";
import ShareChatModal from "components/ShareChatModal";
import ChatInput from "./components/ChatInput";
import Icon from "components/Icon";
import Convo from "./components/Convo";
import { useUsersContext } from "context/usersContext";
import { PromptsContext } from "context/promptsContext";
import MyDropzone from "./components/MyDropzone"; // Import your Dropzone component
import ErrorHandlingModal from "components/ErrorHandlingModal";
import filesubnmitted from "./folder-access.ico";
import "./styles/v3.css";
import EditChatModal from "components/EditChatModal";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import env from "config";
import DeleteChatModal from "components/DeleteChatModal";
import { isToday, isYesterday, subDays } from "date-fns"; // Import date-fns for easier date handling
import ShinyButton from "./components/shiny-button";
import TaskContainer from "./container/TaskContainer";
import SearchContainer from "./container/SearchContainer";
import AddUserModal from "components/AddUserModal";
import { getAssistantWelcomeContent } from "utils/Content";

const BASE_URL = `${env.API_URL}/v1`;

const Chat = ({ match, history }) => {
  const { favouritesData, getFavourites } = useContext(PromptsContext);
  const {
    chats,
    setchats,
    setnewchatloaderhandler,
    users,
    setUserAsUnread,
    SSO,
    addNewMessage,
    contextuploadFilefrominput,
    agencyInfo,
    errorType,
    setErrorType,
    errorMsg,
    ChatSubmit,
    showToast,
    refresh,
    handleDeleteContact,
    GetchatData,
    setOnFromPrompt,
    getLocationUsers,
    locationUsers,
    handleRefreshData,
    streamResponse,
    isStreaming,
    fileLoading,
    setssodata,
    agentEditMode,
    isAuto,
    setIsAuto,
    userTyping,
    setShowRetry,
    setTempData,
    showRetry,
    tempData,
    setErrorMessage,
  } = useUsersContext();

  const favChatIds = favouritesData?.map((fav) => fav.chat_id);
  const favChats = chats?.filter((chat) => favChatIds?.includes(chat.id));
  const userId = match.params.id;
  let user = users.filter((user) => user.id === userId)[0];

  const [showAttach, setShowAttach] = useState(false);
  const [showEmojis, setShowEmojis] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [footerHeight, setFooterHeight] = useState("64px");
  const [, setGoBottomBtn] = useState("120px");
  const [alertModel, setAlertModel] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [saveModel, setsaveModel] = useState(false);
  const [isAgentBuilder, setIsAgentBuilder] = useState(SSO?.openAgentBuilder);

  // const [isModalOpen, setIsModalOpen] = useState(errorType);

  const [, setIsAddPromptModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileType, setFileType] = useState("");
  const [copySelectedFiles, setCopySelectedFiles] = useState([]);
  const [threeDotOptions, setThreeDotOptions] = useState({});
  const [threeDot1Options, setThreeDot1Options] = useState({});
  const [threeDot2Options, setThreeDot2Options] = useState({});
  const [threeDotFavOptions, setThreeDotFavOptions] = useState({});
  const [selectedAssistantId, setSelectedAssistantId] = useState([]);
  const [assistantModel, setassistantModel] = useState(false);
  const [uploadonkbfiles, setuploadonkbfiles] = useState({});
  const [asistantSelected, setasistantSelected] = useState();
  const [askAssistant, setAskAssistant] = useState(false);
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const [startChatWithUseAgent, setStartChatWithUseAgent] = useState(
    SSO?.useAgent,
  );

  const [assistantData, setAssistantData] = useState([]);

  const [showScrollButton, setShowScrollButton] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(null);
  const today = new Date();
  const last7Days = subDays(today, 7); // 7 days ago
  const [showMainBody, setShowMainBody] = useState("chat");
  // Filter chats by categories
  const chatsByToday = chats.filter((item) =>
    isToday(new Date(item.createdAt)),
  );
  const chatsByYesterday = chats.filter((item) =>
    isYesterday(new Date(item.createdAt)),
  );

  // Combine chats that are within the last 7 days and older chats (remaining)
  const chatsByLast7DaysAndOlder = chats.filter((item) => {
    const createdAtDate = new Date(item.createdAt);
    return (
      createdAtDate <= last7Days ||
      (createdAtDate < today &&
        !isYesterday(createdAtDate) &&
        !isToday(createdAtDate))
    );
  });
  // Function to handle sidebar toggling
  const toggleSidebar = (sidebar) => {
    // If the same sidebar is clicked, close it
    if (openSidebar === sidebar) {
      closeAllSidebars(); // Close all sidebars
      setOpenSidebar(null); // No sidebar is open
    }
    // If a different sidebar is clicked, close the current one and open the new one
    else {
      closeAllSidebars(); // Close all sidebars
      openSelectedSidebar(sidebar); // Open the selected sidebar
      setOpenSidebar(sidebar); // Set the selected sidebar as opena
    }
  };

  const handleClick = async () => {
    const updatedValue = !isAuto;
    setIsAuto(updatedValue);
    !updatedValue &&
      window.parent.postMessage({ action: "redirect-ai-agents" }, "*");
  };

  // Function to close all sidebars
  const closeAllSidebars = () => {
    const taskSidebar = document.getElementById("tasksidebar");
    const searchSidebar = document.getElementById("searchsidebar");
    const assistantSidebar = document.getElementById("assistantsidebar");

    if (taskSidebar) taskSidebar.style.width = "0";
    if (searchSidebar) searchSidebar.style.width = "0";
    if (assistantSidebar) assistantSidebar.style.width = "0";
  };

  const openSelectedSidebar = (sidebar) => {
    closeAllSidebars(); // Optional: to close others before opening one

    if (sidebar === "search") {
      const searchSidebar = document.getElementById("searchsidebar");
      if (searchSidebar) searchSidebar.style.width = "380px";
    } else if (sidebar === "task") {
      const taskSidebar = document.getElementById("tasksidebar");
      if (taskSidebar) taskSidebar.style.width = "380px";
    } else if (sidebar === "assistant") {
      const assistantSidebar = document.getElementById("assistantsidebar");
      if (assistantSidebar) assistantSidebar.style.width = "380px";
    }
  };

  const chatContentRef = useRef(null);

  const handleFileSelect = (files) => {
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
    setCopySelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const Assistant = async () => {
    axios
      .get(
        `${BASE_URL}/assistant/fetchbyuser?user_id=${SSO?.userUUID}&location_id=${SSO?.id}`,
      )
      .then((response) => {
        let filteredResponse = response.data.data.filter(
          (item) => item.status && item.ui_enable,
        );
        let match = filteredResponse.find(
          (item) => item.assistant_id === SSO.selected_assistant_id,
        );
        if (match.length === 0)
          match = filteredResponse.find(
            (item) => item.assistant_id === SSO.default_assistant,
          );
        let rearrangedResponse = [];
        if (match) {
          setasistantSelected(match);
          rearrangedResponse = [
            { ...match, selected: true },
            ...filteredResponse
              .filter((item) => item.assistant_id !== SSO.default_assistant)
              .map((item) => ({ ...item, selected: false })),
          ];
        } else {
          rearrangedResponse = [
            ...filteredResponse.map((item) => ({ ...item, selected: false })),
          ];
        }

        if (response.data?.crm_agent) {
          rearrangedResponse.push({
            assistant_name: "CRM Agent",
            modal_name: "openai/gpt-4o",
            assistant_id: response.data?.crm_agent,
            status: true,
          });
        }
        setAssistantData(rearrangedResponse);
      })
      .catch((error) => {
        let updatedResponse = [];
        let filteredResponse = updatedResponse.filter((item) => item.status);
        setAssistantData(filteredResponse);
      });
  };

  const updateLocaStorageForAssistant = (item) => {
    localStorage.setItem("assistant_id", item.assistant_id);
    localStorage.setItem("assistant_name", item.assistant_name);
  };

  const AssistantUpdate = (item) => {
    updateLocaStorageForAssistant(item);
    setasistantSelected(item);
  };

  const changeassistant = (item) => {
    setasistantSelected(item);
    updateLocaStorageForAssistant(item);
    justCloseIt();
    setAskAssistant(false);
  };

  useEffect(() => {
    if (SSO) {
      Assistant();
      setStartChatWithUseAgent(SSO?.useAgent);
      setIsAgentBuilder(SSO?.openAgentBuilder);
    }
  }, [assistantModel, SSO]);

  // useEffect(() => {
  //   if (!user) {
  //     const redirectUrl = `/`;
  //     history.push(redirectUrl);
  //   } else {
  //     scrollToLastMsg();
  //     setUserAsUnread(user.id);
  //   }
  // }, []);

  useEffect(() => {
    const handleRouteMessage = (event) => {
      if (event?.data?.type !== "ROUTE_CHANGE") return;

      if (event.data.fullUrl === "tasks") {
        setShowMainBody("tasks");
      } else {
        setShowMainBody("chat");
      }
    };

    window.addEventListener("message", handleRouteMessage);
    return () => window.removeEventListener("message", handleRouteMessage);
  }, []);

  // useEffect(() => {
  //   setIsModalOpen(errorType);
  // }, [errorType]);

  const handleChatOrAssistantChange = () => {
    if (SSO?.openAgentBuilder) {
      delete SSO?.openAgentBuilder;
      delete SSO?.agentBuilder;
      setIsAgentBuilder(false);
    }
  };

  const createAgentBuilderChat = async () => {
    const payload = {
      locationId: SSO?.id,
      username: SSO?.chat_username,
      assistant_id: SSO?.agentBuilder,
      assistant_name: "Agent Builder",
    };
    const temp = await ChatSubmit(payload);

    if (!temp?.response) {
      refresh(temp);
      const chatUrl = `/chat/${temp.id}`;
      setUserAsUnread(temp.id);
      const assistant = !SSO?.openAgentBuilder
        ? { modal_name: "openai/gpt-4o" }
        : {
            modal_name: SSO?.agentBuilder ? "openai/gpt-4.1" : "openai/gpt-4o",
            assistant_id: SSO?.agentBuilder,
            assistant_name: "Agent Builder",
          };
      if (showRetry == true && tempData !== null) {
        setShowRetry(false);
        setTempData(null);
      }
      addNewMessage(
        temp.id,
        "force restart",
        "force restart",
        "savetodb",
        selectedFiles,
        assistant,
        "notimage",
      );
      history.push(chatUrl);
      // setTimeout(() => handleRefreshData(), 8000);
    } else {
      showToast("Something went wrong!");
    }
    setNewMessage("");
    document.getElementById("gotovie")?.scrollIntoView({ behavior: "smooth" });
    // setnewchatloaderhandler(true);
    setIsAgentBuilder(false);
    // delete SSO?.openAgentBuilder;
    window.parent.postMessage({ action: "consumedOpenAgentBuilder" }, "*");
  };

  const editAgentByBuilder = async () => {
    if (agentEditMode) {
      const assistant = {
        modal_name: SSO?.agentBuilder ? "openai/gpt-4.1" : "openai/gpt-4o",
        assistant_id: SSO?.agentBuilder,
        assistant_name: "Agent Builder",
      };
      if (showRetry == true && tempData !== null) {
        setShowRetry(false);
        setTempData(null);
      }
      addNewMessage(
        SSO?.conversationId,
        "edit mode",
        "edit mode",
        "savetodb",
        selectedFiles,
        assistant,
        "notimage",
      );
      history.push(`/chat/${SSO?.conversationId}`);
      setIsAgentBuilder(false);
      // delete SSO?.openAgentBuilder;
      window.parent.postMessage({ action: "consumedOpenAgentBuilder" }, "*");
    }
  };

  useEffect(() => {
    if (isAgentBuilder && SSO?.conversationId === "") createAgentBuilderChat();
    if (isAgentBuilder && SSO?.conversationId !== "" && agentEditMode)
      editAgentByBuilder();
  }, [isAgentBuilder, agentEditMode, SSO]);

  const StartChatWWithUseAgent = async () => {
    if (startChatWithUseAgent) {
      const payload = {
        locationId: SSO?.id,
        username: SSO?.chat_username,
        assistant_id: asistantSelected?.assistant_id,
        assistant_name: asistantSelected?.assistant_name,
      };
      const temp = await ChatSubmit(payload);
      if (!temp?.response) {
        refresh(temp);
        const assistant = {
          modal_name: "openai/gpt-4o",
          assistant_id: asistantSelected?.assistant_id,
          assistant_name: asistantSelected?.assistant_name,
        };
        if (showRetry == true && tempData !== null) {
          setShowRetry(false);
          setTempData(null);
        }
        addNewMessage(
          temp.id,
          getAssistantWelcomeContent(assistant?.assistant_name),
          getAssistantWelcomeContent(assistant?.assistant_name),
          "savetodb",
          selectedFiles,
          assistant,
          "notimage",
        );
        history.push(`/chat/${temp.id}`);
      } else {
        showToast("Something went wrong!", "error");
      }
      setStartChatWithUseAgent(false);
    }
  };

  useEffect(() => {
    if (startChatWithUseAgent && asistantSelected?.assistant_name) {
      StartChatWWithUseAgent();
    }
  }, [startChatWithUseAgent, asistantSelected]);

  const justCloseIt = () => {
    setErrorType(false);
    setIsAddPromptModal(false);
    setEditModel(false);
    setThreeDotOptions({});
    setThreeDot1Options({});
    setThreeDot2Options({});
    setIsOpendrop(false);
    setAskToDeleteModal(false);
    setassistantModel(false);
    setIsOpendrop(false);
    setAskToShareModal(false);

    // Add null checks before accessing style properties
    const searchSidebar = document.getElementById("searchsidebar");
    const taskSidebar = document.getElementById("tasksidebar");
    const assistantSidebar = document.getElementById("assistantsidebar");

    if (searchSidebar) {
      searchSidebar.style.width = "0";
    }
    if (taskSidebar) {
      taskSidebar.style.width = "0";
    }
    if (assistantSidebar) {
      assistantSidebar.style.width = "0";
    }

    setLoader(false);
  };

  useEffect(() => {
    if (footerHeight) {
      const newHeight = parseInt(footerHeight.replace(/\D/g, "")) + 56 + "px";
      setGoBottomBtn(newHeight);
    }
  }, [footerHeight]);

  const LoadTaskonchat = async (user_msg, prompt) => {
    // If there is an active chat, send the message there. Otherwise, create a new chat as before.
    setOnFromPrompt(SSO?.userUUID);
    if (user) {
      const assistant =
        asistantSelected?.modal_name !== ""
          ? asistantSelected
          : "openai/gpt-4o";
      if (showRetry == true && tempData !== null) {
        setShowRetry(false);
        setTempData(null);
      }
      addNewMessage(
        user.id,
        user_msg,
        prompt,
        "savetodb",
        selectedFiles,
        assistant,
        "notimage",
      );
      setNewMessage("");
      document
        .getElementById("gotovie")
        ?.scrollIntoView({ behavior: "smooth" });
    } else {
      // fallback to previous behavior: create a new chat for the task
      const assistantRes = await axios.get(
        `${BASE_URL}/assistant/custom-task-agent?agency_id=${SSO?.agency_id}&assistant_type=Custom Task`,
      );
      const payload = {
        locationId: SSO?.id,
        username: SSO?.chat_username,
        assistant_id: assistantRes?.data?.data
          ? assistantRes?.data?.data?.assistant_id
          : asistantSelected?.assistant_id,
        assistant_name: assistantRes?.data?.data
          ? assistantRes?.data?.data?.assistant_name
          : asistantSelected?.assistant_name,
      };
      const temp = await ChatSubmit(payload, true);
      if (!temp?.response) {
        refresh(temp);
        const chatUrl = `/chat/${temp.id}`;
        setUserAsUnread(temp.id);
        const assistant =
          asistantSelected?.modal_name !== ""
            ? asistantSelected
            : "openai/gpt-4o";
        if (showRetry == true && tempData !== null) {
          setShowRetry(false);
          setTempData(null);
        }
        addNewMessage(
          temp.id,
          user_msg,
          prompt,
          "savetodb",
          selectedFiles,
          assistant,
          "notimage",
        );
        history.push(chatUrl);
      } else {
        setNewMessage("");
        document
          .getElementById("gotovie")
          ?.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  const CreateNewChat = async () => {
    const payload = {
      locationId: SSO?.id,
      username: SSO?.chat_username,
      assistant_id: !isAuto ? asistantSelected?.assistant_id : "",
      assistant_name: !isAuto ? asistantSelected?.assistant_name : "",
    };
    const temp = await ChatSubmit(payload);

    if (!temp?.response) {
      refresh(temp);
      const chatUrl = `/chat/${temp.id}`;
      setUserAsUnread(temp.id);
      const assistant =
        asistantSelected?.modal_name !== ""
          ? asistantSelected
          : "openai/gpt-4o";
      history.push(chatUrl);
      setTimeout(() => {
        setNewMessage("");
      }, 2000);
      if (showRetry == true && tempData !== null) {
        setShowRetry(false);
        setTempData(null);
      }
      await addNewMessage(
        temp.id,
        newMessage,
        newMessage,
        "savetodb",
        selectedFiles,
        assistant,
        "notimage",
      );
    } else {
      showToast("Something went wrong!");
    }
    document.getElementById("gotovie")?.scrollIntoView({ behavior: "smooth" });
    setnewchatloaderhandler(true);
  };

  const submitNewMessage = (
    prompt = newMessage,
    type = "savetodb",
    messagetype = "notimage",
  ) => {
    if (selectedFiles.length >= 10) {
      const container = document.getElementById("errorofmaxfile");
      let div = document.createElement("div");
      div.style.display = "flex";
      div.style.justifyContent = "center";
      div.className = "file_upload_input";
      div.innerHTML = `
      <span style="position: absolute; top: 5px; right: 10px; cursor: pointer;" onclick="this.parentElement.remove()">&#10005;</span>
      <p style="padding: 15px; margin: 0px; color: red; text-align: center;">
          You can only upload 10 files at a time
      </p>
  `;
      container.appendChild(div);

      // Automatically remove the div after 5 seconds
      setTimeout(() => {
        div.remove();
      }, 5000);

      return true;
    }
    setSelectedFiles([]);
    // scrollToLastMsg();
    const assistant =
      asistantSelected?.modal_name !== "" && !SSO?.openAgentBuilder
        ? asistantSelected
        : asistantSelected?.modal_name !== "" && SSO?.openAgentBuilder
          ? {
              modal_name: "openai/gpt-4o.1",
              assistant_id: SSO?.agentBuilder,
              assistant_name: "Agent Builder",
            }
          : "openai/gpt-4o";
    if (showRetry == true && tempData !== null) {
      setShowRetry(false);
      setTempData(null);
    }
    addNewMessage(
      user.id,
      newMessage,
      prompt,
      type,
      selectedFiles,
      assistant,
      messagetype,
      fileType,
    );
    setNewMessage("");
    // scrollToLastMsg();
    setFileType("");

    document.getElementById("gotovie")?.scrollIntoView({ behavior: "smooth" });
  };

  const gettingfilefromdropzone = async (files) => {
    var response = await contextuploadFilefrominput(user.id, files);
    if (response === "uploaded") {
      setAlertModel(false);
      setSuccessModel(true);
    } else {
    }
  };

  const toggleThreeDotOption = (index) => {
    setThreeDotOptions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const toggleThree1DotOption = (index) => {
    setThreeDot1Options((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const toggleThree2DotOption = (index) => {
    setThreeDot2Options((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleThreeFavDotOption = (index) => {
    setThreeDotFavOptions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const [isOpen, setIsOpen] = useState(true);

  const openNav = () => {
    setIsOpen(true);
    const removeElement = document.getElementById("outsidebar");
    if (removeElement) {
      removeElement.style.display = "none";
    }
  };

  const closeNav = () => {
    setIsOpen(false);
    const removeElement = document.getElementById("outsidebar");
    if (removeElement) {
      removeElement.style.display = "block";
    }
  };

  useEffect(() => {
    isOpen ? openNav() : closeNav();
  }, [isOpen, showMainBody]);

  const [, setIsOpendrop] = useState(false);

  const handleSubmit = async (item = []) => {
    // First, try to find existing chat with empty messages
    delete SSO?.agentBuilder;
    delete SSO?.conversationId;
    delete SSO?.openAgentBuilder;
    setIsAgentBuilder(false);
    const existingChat = chats.find(
      (chat) =>
        chat.assistant_id ===
          (item?.assistant_id || asistantSelected?.assistant_id) &&
        chat.locationId === SSO?.id &&
        chat.messages?.[`Welcome ${SSO?.chat_username}`]?.length === 0,
    );

    if (existingChat) {
      // Navigate to existing empty chat
      const chatUrl = `/chat/${existingChat.id}`;
      setUserAsUnread(existingChat.id);
      history.push(chatUrl);
      return;
    }

    // If no existing chat with empty messages, create new chat
    const payload = {
      locationId: SSO?.id,
      username: SSO?.chat_username,
      assistant_id: item ? item.assistant_id : asistantSelected?.assistant_id,
      assistant_name: item
        ? item.assistant_name
        : asistantSelected?.assistant_name,
    };

    const temp = await ChatSubmit(payload, false, false);

    if (!temp?.response) {
      refresh(temp);
      setIsAuto(true);
      setasistantSelected();
      const chatUrl = `/chat/${temp.id}`;
      setUserAsUnread(temp.id);
      history.push(chatUrl);
      setTimeout(() => {
        Refershchat();
      }, 2000);
    } else {
      showToast("Something went wrong!", "err");
    }
  };

  const [askToDeleteModal, setAskToDeleteModal] = useState(false);
  const askToDelete = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectedContact(chat);
    setAskToDeleteModal(true);
  };
  const handleDeleteClick = () => {
    handleDeleteContact(selectedContact.id);
    justCloseIt();
    setTimeout(() => {
      Refershchat();
    }, 2000);
  };

  const [EditModel, setEditModel] = useState(false);
  const [selectedContact, setSelectedContact] = useState();

  const handleeditchat = (chat) => {
    setEditModel(true);
    setSelectedContact(chat);
  };
  const Refershchat = async () => {
    try {
      const chatupdated = await GetchatData();
      setchats(chatupdated);
      await getFavourites();
      // await handleRefreshData();
    } catch (error) {
      console.error("Error refreshing chat and fetching favourites:", error);
    }
  };
  const handleFavourite = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    const response = await axios.get(
      `${BASE_URL}/chat/add/favourite?chat_id=${chat?.id}&user_id=${SSO?.userUUID}&location_id=${SSO?.id}`,
    );
    if (response) {
      await Refershchat();
      justCloseIt();
    }
  };

  const removeFromFav = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    const favoriteId = favouritesData.find(
      (favorite) => favorite.chat_id === chat?.id,
    )?._id;
    const response = await axios.get(
      `${BASE_URL}/chat/remove/favourite?chatId=${favoriteId}&user_id=${SSO?.userUUID}&location_id=${SSO?.id}`,
    );
    if (response) {
      Refershchat();
      justCloseIt();
    }
  };
  const UploadOnKB = async (file) => {
    setassistantModel(true);
    setuploadonkbfiles(file);
  };
  const uploadonKBSendTobackend = async (e) => {
    e.preventDefault();
    setLoader(true);
    const payload = {
      username: SSO?.chat_username,
      profile_id: SSO?.id,
      assistant_ids: selectedAssistantId,
      file_id: uploadonkbfiles.name,
    };
    const response = await axios.post(`${BASE_URL}/chat/uploadonkb`, payload, {
      "Content-Type": "multipart/form-data",
    });
    if (response) {
      Refershchat();
      setSelectedAssistantId([]);
      justCloseIt();
      setsaveModel(true);
    }
  };

  const threeDotRef = useRef(null);
  const threeDot1Ref = useRef(null);
  const threeDot2Ref = useRef(null);
  const AskAssistantRef = useRef(null);
  const threeDotFavRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        AskAssistantRef.current &&
        !AskAssistantRef.current.contains(event.target)
      ) {
        setAskAssistant(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [AskAssistantRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (threeDotRef.current && !threeDotRef.current.contains(event.target)) {
        setThreeDotOptions({});
      }
      if (
        threeDot1Ref.current &&
        !threeDot1Ref.current.contains(event.target)
      ) {
        setThreeDot1Options({});
      }
      if (
        threeDot2Ref.current &&
        !threeDot2Ref.current.contains(event.target)
      ) {
        setThreeDot2Options({});
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [threeDotRef, threeDot1Ref, threeDot2Ref]);

  const AssistantDropdown = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        AssistantDropdown.current &&
        !AssistantDropdown.current.contains(event.target)
      ) {
        setIsOpendrop(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [AssistantDropdown]);

  const handleAssistantSelect = (item) => {
    if (selectedAssistantId.includes(item.assistant_id)) {
      setSelectedAssistantId((prevItems) =>
        prevItems.filter((id) => id !== item.assistant_id),
      );
    } else {
      setSelectedAssistantId((prevItems) => [...prevItems, item.assistant_id]);
    }
  };

  const handleScroll = useCallback(() => {
    if (chatContentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContentRef.current;
      const isAtBottom = scrollHeight - scrollTop === clientHeight;
      setShowScrollButton(!isAtBottom);
    }
  }, []);

  useEffect(() => {
    const chatContent = chatContentRef.current;
    if (chatContent) {
      chatContent.addEventListener("scroll", handleScroll);
      return () => chatContent.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const updateAssistant = (item) => {
    changeassistant(item);
  };

  const [askToShareModal, setAskToShareModal] = useState(false);
  const askToShare = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectedContact(chat);
    setAskToShareModal(true);
  };

  const firstKey = Object.keys(user?.messages || {})[0];
  const messagesFiles = user?.messages?.[firstKey];

  let dropDownFiles = [];

  if (Array.isArray(messagesFiles)) {
    const messagesWithFiles = messagesFiles.filter(
      (msg) => Array.isArray(msg.file_ids) && msg.file_ids.length > 0,
    );

    const fileNames = messagesWithFiles.flatMap((msg) =>
      msg.file_ids.map((file) => file.name),
    );

    dropDownFiles = fileNames;
  } else {
  }

  const [filesPopupOpen, setFilesPopupOpen] = useState(false);

  useEffect(() => {
    if (dropDownFiles?.length === 0) setFilesPopupOpen(false);
  }, [dropDownFiles]);

  return (
    <>
      <EditChatModal
        isModalOpen={EditModel}
        edit_data={selectedContact}
        justCloseIt={justCloseIt}
        refreshChat={Refershchat}
      />
      <DeleteChatModal
        modelType="Chat"
        isModalOpen={askToDeleteModal}
        contact={selectedContact}
        yesDelete={handleDeleteClick}
        justCloseIt={justCloseIt}
        type="prompt"
      />
      <ShareChatModal
        isModalOpen={askToShareModal}
        contact={selectedContact}
        justCloseIt={justCloseIt}
        getLocationUsers={getLocationUsers}
        locationUsers={locationUsers}
        handleRefreshData={handleRefreshData}
      />
      <div className={`v_3sidebar ${isOpen ? "v_3sidebar--open" : ""}`}>
        <div className="v3setonsidebaricon">
          <div
            style={{ cursor: "pointer", position: "relative" }}
            aria-label="Toggle sidebar"
            className="scrollchat hover-text-right"
            onClick={closeNav}
          >
            <Icon id="tooglesidebar" />
            <span className="tooltip-text-right">{"Close Sidebar"}</span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{ position: "relative" }}
              onClick={() => setShowMainBody("search")}
              className="v3sidebarlistExtra hover-text-left"
            >
              <Icon id="v3_search" />
              <span className="tooltip-text-left">{"Search"}</span>
            </div>

            <div
              onClick={() => {
                if (!userTyping) {
                  handleSubmit(asistantSelected);
                  setShowMainBody("chat");
                  setShowRetry(null);
                  setTempData(null);
                  setErrorMessage("");
                } else {
                  showToast("Wait for agent response", "error");
                }
              }}
              style={{
                position: "relative",
                cursor: "pointer",
                margin: "0px 20px 0px 0px",
              }}
            >
              <div class="v3sidebarlist hover-text-left">
                <Icon id="plus" />

                <span className="tooltip-text-left">{"New Chat"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="v3_list_main">
          <div
            className="v3_sec_sidebar__openbtn"
            onClick={() => setShowMainBody("tasks")}
          >
            <div className="v3sidebarlist">
              <Icon id="v3_4dots" />
              <div
                style={{ cursor: "pointer", margin: "0px 20px" }}
                aria-label="New chat"
              >
                Task
              </div>
            </div>
          </div>

          {favChats.map((item, index) => (
            <div ref={threeDotFavRef}>
              <Link
                onClick={() => {
                  setUserAsUnread(item.id);
                  AssistantUpdate(item);
                  setShowMainBody("chat");
                  handleChatOrAssistantChange();
                  setShowRetry(null);
                  setTempData(null);
                  setErrorMessage("");
                }}
                to={`/chat/${item.id}`}
              >
                <div
                  className="v3_chatlisr"
                  style={{
                    position: "relative",
                    background: userId === item.id ? "#E5E5E5" : "transparent",
                  }}
                >
                  <div
                    style={{ width: "10%" }}
                    onClick={(e) => removeFromFav(e, item)}
                  >
                    <Icon id="pintask" />
                  </div>

                  <div
                    style={{
                      cursor: "pointer",
                      margin: "0px 20px",
                      width: "90%",
                    }}
                    aria-label="New chat"
                    className="v3_chatlist_title"
                  >
                    {item.name}
                  </div>
                  <div
                    style={{
                      width: "10%",
                      transform: "rotate(90deg)",
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                    }}
                    onClick={(e) => {
                      toggleThreeFavDotOption(index);
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <Icon id="threeDots" />
                  </div>
                  {threeDotFavOptions[index] && (
                    <div className="v3_three_dots_options_sidebar">
                      <div
                        className="v3_three_dots_options_box"
                        onClick={() => handleeditchat(item)}
                      >
                        <div className="v3_three_dots_options_icon">
                          <Icon id="pencilblack" style={{ fontSize: "12px" }} />
                        </div>
                        <p className="v3_three_dots_options_text">Rename</p>
                      </div>

                      <div
                        className="v3_three_dots_options_box"
                        onClick={(e) => askToShare(e, item)}
                      >
                        <div className="v3_three_dots_options_icon">
                          <Icon id="share" style={{ fontSize: "12px" }} />
                        </div>
                        <p className="v3_three_dots_options_text">Share</p>
                      </div>

                      <div
                        className="v3_three_dots_options_box"
                        onClick={(e) => askToDelete(e, item)}
                      >
                        <div className="v3_three_dots_options_icon">
                          <Icon id="delete" style={{ fontSize: "12px" }} />
                        </div>
                        <p className="v3_three_dots_options_text">Delete</p>
                      </div>
                    </div>
                  )}
                </div>
              </Link>
            </div>
          ))}

          <div ref={threeDotRef}>
            <div className="dateWiseWrap">
              <h5 className="datewise">Today</h5>
            </div>
            {chatsByToday
              .filter((item) =>
                item.userId.some(
                  (user) =>
                    (user.id === SSO?.userUUID ||
                      user.id === SSO?.UserInfo?.userId) &&
                    (user.type === "author" || user.type === "shared"),
                ),
              )
              .filter((item) => !favChats.some((fav) => fav.id === item.id))
              .filter(
                (item) =>
                  item.name !== "force restart" &&
                  item.name !== "Force restart" &&
                  item.name !== "Force Restart" &&
                  item.name !== "",
              )
              .map((item, index) => (
                <Link
                  onClick={() => {
                    setUserAsUnread(item.id);
                    AssistantUpdate(item);
                    handleChatOrAssistantChange();
                    setShowMainBody("chat");
                    setShowRetry(null);
                    setTempData(null);
                    setErrorMessage("");
                  }}
                  to={`/chat/${item.id}`}
                >
                  <div
                    className="v3_chatlisr"
                    style={{
                      position: "relative",
                      background:
                        userId === item.id ? "#E5E5E5" : "transparent",
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        margin: "0px 20px",
                        width: "90%",
                      }}
                      aria-label="New chat"
                      className="v3_chatlist_title"
                    >
                      {item.name}
                    </div>

                    <div
                      style={{
                        width: "10%",
                        transform: "rotate(90deg)",
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                      }}
                      onClick={(e) => {
                        toggleThreeDotOption(index);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <Icon id="threeDots" />
                    </div>

                    {threeDotOptions[index] && (
                      <div className="v3_three_dots_options_sidebar">
                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => handleFavourite(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="pintask" style={{ fontSize: "12px" }} />
                          </div>
                          <p className="v3_three_dots_options_text">Pin</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={() => handleeditchat(item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon
                              id="pencilblack"
                              style={{ fontSize: "12px" }}
                            />
                          </div>
                          <p className="v3_three_dots_options_text">Rename</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToShare(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="share" style={{ fontSize: "12px" }} />
                          </div>
                          <p className="v3_three_dots_options_text">Share</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToDelete(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="delete" style={{ fontSize: "12px" }} />
                          </div>
                          <p className="v3_three_dots_options_text">Delete</p>
                        </div>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
          </div>
          <div ref={threeDot1Ref}>
            <div className="dateWiseWrap">
              <h5 className="datewise">Yesterday</h5>
            </div>
            {chatsByYesterday
              .filter((item) =>
                item.userId.some(
                  (user) =>
                    (user.id === SSO?.userUUID ||
                      user.id === SSO?.UserInfo?.userId) &&
                    (user.type === "author" || user.type === "shared"),
                ),
              )
              .filter((item) => !favChats.some((fav) => fav.id === item.id))
              .filter(
                (item) =>
                  item.name !== "force restart" &&
                  item.name !== "Force restart" &&
                  item.name !== "Force Restart" &&
                  item.name !== "",
              )
              .map((item, index) => (
                <Link
                  onClick={() => {
                    setUserAsUnread(item.id);
                    AssistantUpdate(item);
                    handleChatOrAssistantChange();
                    setShowMainBody("chat");
                    setShowRetry(null);
                    setTempData(null);
                    setErrorMessage("");
                  }}
                  to={`/chat/${item.id}`}
                >
                  <div
                    className="v3_chatlisr"
                    style={{
                      position: "relative",
                      background:
                        userId === item.id ? "#E5E5E5" : "transparent",
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        margin: "0px 20px",
                        width: "90%",
                      }}
                      aria-label="New chat"
                      className="v3_chatlist_title"
                    >
                      {item.name}
                    </div>

                    <div
                      style={{
                        width: "10%",
                        transform: "rotate(90deg)",
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                      }}
                      onClick={(e) => {
                        toggleThree1DotOption(index);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <Icon id="threeDots" />
                    </div>

                    {threeDot1Options[index] && (
                      <div className="v3_three_dots_options_sidebar">
                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => handleFavourite(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="pintask" />
                          </div>
                          <p className="v3_three_dots_options_text">Pin</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={() => handleeditchat(item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="pencilblack" />
                          </div>
                          <p className="v3_three_dots_options_text">Rename</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToShare(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="share" />
                          </div>
                          <p className="v3_three_dots_options_text">Share</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToDelete(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="delete" />
                          </div>
                          <p className="v3_three_dots_options_text">Delete</p>
                        </div>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
          </div>
          <div ref={threeDot2Ref}>
            <div className="dateWiseWrap">
              <h5 className="datewise">Previous 7 Days</h5>
            </div>
            {chatsByLast7DaysAndOlder
              .filter((item) =>
                item.userId.some(
                  (user) =>
                    (user.id === SSO?.userUUID ||
                      user.id === SSO?.UserInfo?.userId) &&
                    (user.type === "author" || user.type === "shared"),
                ),
              )
              .filter((item) => !favChats.some((fav) => fav.id === item.id))
              .filter(
                (item) =>
                  item.name !== "force restart" &&
                  item.name !== "Force restart" &&
                  item.name !== "Force Restart" &&
                  item.name !== "",
              )
              .map((item, index) => (
                <Link
                  onClick={() => {
                    setUserAsUnread(item.id);
                    AssistantUpdate(item);
                    handleChatOrAssistantChange();
                    setShowMainBody("chat");
                    setShowRetry(null);
                    setTempData(null);
                    setErrorMessage("");
                  }}
                  to={`/chat/${item.id}`}
                >
                  <div
                    className="v3_chatlisr"
                    style={{
                      position: "relative",
                      background:
                        userId === item.id ? "#E5E5E5" : "transparent",
                    }}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        margin: "0px 20px",
                        width: "90%",
                      }}
                      aria-label="New chat"
                      className="v3_chatlist_title"
                    >
                      {item.name}
                    </div>

                    <div
                      style={{
                        width: "10%",
                        transform: "rotate(90deg)",
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                      }}
                      onClick={(e) => {
                        toggleThree2DotOption(index);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <Icon id="threeDots" />
                    </div>

                    {threeDot2Options[index] && (
                      <div className="v3_three_dots_options_sidebar">
                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => handleFavourite(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="pintask" />
                          </div>
                          <p className="v3_three_dots_options_text">Pin</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={() => handleeditchat(item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="pencilblack" />
                          </div>
                          <p className="v3_three_dots_options_text">Rename</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToShare(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="share" />
                          </div>
                          <p className="v3_three_dots_options_text">Share</p>
                        </div>

                        <div
                          className="v3_three_dots_options_box"
                          onClick={(e) => askToDelete(e, item)}
                        >
                          <div className="v3_three_dots_options_icon">
                            <Icon id="delete" />
                          </div>
                          <p className="v3_three_dots_options_text">Delete</p>
                        </div>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
          </div>
        </div>
        {isOpen && (
          <div
            style={{
              width: "250px",
              position: "fixed",
              bottom: 0,
              right: 0,
              left: 0,
              background: "#fff",
            }}
          >
            <div
              className="add-team-button"
              onClick={() =>
                window.parent.postMessage({ action: "redirect-team" }, "*")
              }
            >
              <span>
                <Icon id={"AddTeamMember"} />
                <span style={{ marginLeft: "10px", fontWeight: "medium" }}>
                  Invite Team Members{" "}
                </span>
              </span>
            </div>
          </div>
        )}
      </div>
      <div id="v_3main" className={isOpen ? "v_3main--shift" : ""}>
        {SSO?.is_support !== "true" && (
          <div id="outsidebar">
            <div className="v3setsidebaricon">
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  color: "#303030",
                }}
                aria-label="Toggle sidebar"
                className="scrollchat hover-text-right"
                onClick={openNav} // Add onClick event to toggle the sidebar
              >
                <Icon id="tooglesidebar" />
                <span className="tooltip-text-right">{"Open Sidebar"}</span>
              </div>
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  color: "#303030",
                }}
                aria-label="Toggle sidebar"
                className="scrollchat hover-text-right"
                onClick={() => {
                  setShowMainBody("search");
                }} // Corrected: use a function to call both
              >
                <Icon id="search" />
                <span className="tooltip-text-right">{"Search"}</span>
              </div>

              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  color: "#303030",
                }}
                aria-label="Toggle sidebar"
                className="scrollchat hover-text-right"
                onClick={() => {
                  handleSubmit(asistantSelected);
                  setShowMainBody("chat");
                  setShowRetry(null);
                  setTempData(null);
                  setErrorMessage("");
                }}
              >
                <Icon id="plus" />
                <span className="tooltip-text-right">{"New Chat"}</span>
              </div>
              <div
                style={{
                  cursor: "pointer",
                  position: "relative",
                  color: "#303030",
                }}
                aria-label="Toggle sidebar"
                className="scrollchat hover-text-right"
                onClick={() => setOpenTeamModal(true)}
              >
                <Icon id="AddTeamMember" />
                <span className="tooltip-text-right">
                  {"Invite Team Members"}
                </span>
              </div>
              {/* <div onClick={() => handleSubmit(asistantSelected)}
                style={{ position: "relative", cursor: "pointer", margin: "0px 20px" }}>
                <div class="v3_chatnew_hover-text">
                <Icon id="newchatIcon" />
                <span class="v3_chatnew_tooltip-text" >New Chat</span>
                </div>
                </div> */}
            </div>
          </div>
        )}
        {showMainBody === "chat" && (
          <div className="chat__body">
            <div className="v3_chat_bg">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 20px",
                  position: "relative",
                }}
              >
                {/* <ShinyButton
                  agentBuilder={SSO?.agentBuilder}
                  disabled={
                    user?.messages
                      ? Object.values(user?.messages)?.[0]?.length
                      : SSO?.openAgentBuilder
                  }
                  handleClick={handleClick}
                  isAuto={isAuto}
                /> */}

                <div>
                  {dropDownFiles?.length > 0 && (
                    <div>
                      <span
                        style={{
                          marginRight: "5px",
                          color: "#757575",
                          fontSize: "12px",
                        }}
                      >
                        <Icon id="filePdf" />
                      </span>

                      {dropDownFiles?.length > 0 && (
                        <button
                          style={{
                            position: "relative",
                            fontSize: "12px",
                            color: "#757575",
                            outline: "none",
                          }}
                          onClick={() => setFilesPopupOpen((prev) => !prev)} // ⬅️ add this
                        >
                          {/* popup */}
                          <div
                            id="errorofmaxfile"
                            style={{
                              position: "absolute",
                              top: "25px",
                              left: "-25px",
                              zIndex: 9999,
                              gap: "10px",
                              width: "100px",
                              display: filesPopupOpen ? "block" : "none", // ⬅️ hide / show
                            }}
                          >
                            {dropDownFiles?.map((file, index) => {
                              const isFirst = index === 0;
                              const isLast = index === file.length - 1;

                              const borderRadiusStyle = {
                                borderRadius: `${isFirst ? "5px" : "0px"} ${
                                  isFirst ? "5px" : "0px"
                                } ${isLast ? "5px" : "0px"} ${
                                  isLast ? "5px" : "0px"
                                }`,
                                width: "242px",
                              };

                              return (
                                <div
                                  key={index}
                                  className="file_upload_input1 position-relative"
                                  style={borderRadiusStyle}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>
                                      <Icon id="filePdf" />
                                    </span>
                                    <p
                                      style={{ padding: "15px", margin: "0px" }}
                                    >
                                      {file.length > 10
                                        ? `${file.slice(0, 10)}...`
                                        : file}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {dropDownFiles?.length} attached files{" "}
                          <Icon id="upArrow12" color="#757575" />
                        </button>
                      )}
                    </div>
                  )}

                  {user && (
                    <div
                      className=""
                      style={{
                        cursor: "pointer",
                        color: "#303030",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e) => askToShare(e, user)}
                    >
                      <div className="v3_three_dots_options_icon">
                        <Icon id="share" />
                      </div>
                      <p className="v3_three_dots_options_text">Share</p>
                    </div>
                  )}
                </div>
              </div>
              <div
                className="v3chat__content"
                ref={chatContentRef}
                style={{
                  marginLeft: "73px",
                }}
              >
                <div
                  style={{
                    paddingBottom: "15px",
                    maxHeight: "calc(100vh - 320px)",
                    maxWidth: "70vw",
                  }}
                  className="v3chat__inner-content"
                >
                  {user ? (
                    <Convo
                      isAuto={isAuto}
                      userId={userId}
                      messages={user.messages}
                      newMessage={newMessage}
                      setNewMessage={setNewMessage}
                      submitNewMessage={submitNewMessage}
                      agencyInfo={agencyInfo}
                      copySelectedFiles={copySelectedFiles}
                      selectedFiles={selectedFiles}
                      UploadOnKB={UploadOnKB}
                      asistantSelected={asistantSelected}
                      assistantData={assistantData}
                      IsStreamApi={SSO.is_streaming_Api}
                      streamResponse={streamResponse}
                      isStreaming={isStreaming}
                      fileLoading={fileLoading}
                    />
                  ) : (
                    <>
                      {!isAgentBuilder && (
                        <div style={{ fontSize: "45px" }} className="v3iconBox">
                          <span
                            style={{
                              color: "#919191",
                              fontWeight: "600",
                              textTransform: "capitalize",
                            }}
                          >
                            {" "}
                            Hi {SSO?.chat_username}
                          </span>
                          <p style={{ color: "black", fontWeight: "600" }}>
                            {agencyInfo?.Customization?.chatapp_text}
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {showScrollButton && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="down_arrow_icon"
                      style={{
                        position: "fixed",
                        bottom: "170px",
                        zIndex: +9999,
                        cursor: "pointer",
                      }}
                    >
                      <Icon id="chatDownArrow" />
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  width: "100%",
                  height: "220px",
                  position: "absolute",
                  right: 0,
                  bottom: 0,
                }}
              >
                <footer
                  className="v3chat__footer"
                  style={{ zIndex: +9999, paddingBottom: 0 }}
                >
                  {askAssistant && (
                    <div ref={AskAssistantRef}>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)", // 3 equal columns
                          gap: "5px", // Space between items
                        }}
                      >
                        {assistantData?.slice(0, 9)?.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => changeassistant(item)}
                            className="v3_dropdown_optionvaluefatymenu"
                            style={{
                              width: "100%", // Ensures 3 items fit within 270px
                              boxSizing: "border-box",
                              textAlign: "left",
                              padding: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <label
                              style={{
                                margin: "0",
                                cursor: "pointer",
                                padding: "30px 20px",
                              }}
                            >
                              <b>{item?.assistant_name}</b>
                            </label>
                          </div>
                        ))}
                      </div>
                      <div style={{ textAlign: "right", padding: "0px 20px" }}>
                        <span
                          style={{
                            color: "blue",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            openNav();
                            openSelectedSidebar("assistant");
                          }}
                        >
                          See more AI Agent {">"}
                        </span>
                      </div>
                    </div>
                  )}

                  <ChatInput
                    openAgentBuilder={SSO?.openAgentBuilder}
                    agentBuilder={SSO?.agentBuilder}
                    messages={user?.messages}
                    isAuto={isAuto}
                    showEmojis={showEmojis}
                    setShowEmojis={setShowEmojis}
                    showAttach={showAttach}
                    setShowAttach={setShowAttach}
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    submitNewMessage={
                      userId !== undefined ? submitNewMessage : CreateNewChat
                    }
                    setFooterHeight={setFooterHeight}
                    footerHeight={footerHeight}
                    agencyInfo={agencyInfo}
                    chatId={userId}
                    onFileSelect={handleFileSelect}
                    selectedFiles={selectedFiles}
                    updatestateodfiles={setSelectedFiles}
                    setSelectedFiles={setSelectedFiles}
                    setFileType={setFileType}
                    asistantSelected={asistantSelected}
                    setAskAssistant={setAskAssistant}
                    askAssistant={askAssistant}
                  />

                  <p
                    className="text-center text-gray"
                    style={{ marginLeft: "73px" }}
                  >
                    Your data is not used to train our models. AI can make
                    mistakes please check your answer.
                  </p>
                </footer>
              </div>

              {alertModel && (
                <>
                  <div
                    className="modal-zz"
                    onClick={() => setAlertModel(false)}
                  >
                    <div
                      className="modal-content-zz"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <p
                        style={{
                          position: "absolute",
                          right: 5,
                          width: "12px",
                          top: "10px",
                          height: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => setAlertModel(false)}
                      ></p>

                      <MyDropzone
                        gettingfilefromdropzone={gettingfilefromdropzone}
                      />
                    </div>
                  </div>
                </>
              )}
              {successModel && (
                <>
                  <div
                    className="modal-zz"
                    onClick={() => setSuccessModel(false)}
                  >
                    <div
                      className="modal-content-zz"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <p
                        style={{
                          position: "absolute",
                          right: 5,
                          width: "12px",
                          top: "10px",
                          height: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => setSuccessModel(false)}
                      >
                        X
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={filesubnmitted}
                          width={"200px"}
                          height={"200px"}
                        />

                        <h1 className="text-center">Files are Submitted!</h1>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {saveModel && (
                <>
                  <div className="modal-zz" onClick={() => setsaveModel(false)}>
                    <div
                      className="modal-content-zz"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <p
                        style={{
                          position: "absolute",
                          right: 5,
                          width: "12px",
                          top: "10px",
                          height: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => setsaveModel(false)}
                      >
                        X
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={filesubnmitted}
                          width={"200px"}
                          height={"200px"}
                        />

                        <h1 className="text-center">
                          File added in the assistant
                        </h1>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {assistantModel && (
                <>
                  <div
                    className="modal-zz"
                    onClick={() => setassistantModel(false)}
                  >
                    <div
                      className="modal-content-zz"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <p
                        style={{
                          position: "absolute",
                          right: 5,
                          width: "12px",
                          top: "10px",
                          height: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => setassistantModel(false)}
                      >
                        X
                      </p>
                      <div>
                        <b className="text_black">Select Assistant</b>

                        <div style={{ maxHeight: "350px", overflow: "auto" }}>
                          {assistantData?.map(
                            (item, index) =>
                              item.readonly !== true && (
                                <div
                                  className="select_assistat_body"
                                  key={index}
                                >
                                  <div>
                                    <b>{item.assistant_name}</b>
                                  </div>

                                  <div
                                    className="v3_modal_table_body_input"
                                    style={{ marginRight: "14px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{ cursor: "pointer" }}
                                      onChange={() =>
                                        handleAssistantSelect(item)
                                      }
                                      checked={selectedAssistantId.includes(
                                        item.assistant_id,
                                      )} // Update checkbox based on state
                                    />
                                  </div>
                                </div>
                              ),
                          )}
                        </div>
                        {loader ? (
                          <button className="v3_modal_table_button position-relative disabled-button">
                            <spiner className="loader-v3"></spiner>{" "}
                            <span style={{ padding: "10px 20px" }}>Save</span>
                          </button>
                        ) : (
                          <button
                            onClick={uploadonKBSendTobackend}
                            className="v3_modal_table_button position-relative"
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* <ErrorHandlingModal
                isModalOpen={isModalOpen}
                justCloseIt={justCloseIt}
                errorMessage={errorMsg}
                type={errorType}
              /> */}
            </div>
          </div>
        )}

        {showMainBody === "tasks" && (
          <div id="v_3main" style={{ background: "white !important" }}>
            <TaskContainer
              toggleSidebar={toggleSidebar}
              assistantData={assistantData}
              LoadTaskonchat={LoadTaskonchat}
              asistantSelected={asistantSelected}
              closeNav={closeNav}
              setShowMainBody={setShowMainBody}
              handleRefreshData={handleRefreshData}
            />
          </div>
        )}
        {showMainBody === "search" && (
          <div id="v_3main" style={{ background: "white !important" }}>
            <SearchContainer
              toggleSidebar={toggleSidebar}
              updateAssistant={updateAssistant}
              assistantData={assistantData}
              LoadTaskonchat={LoadTaskonchat}
              closeNav={closeNav}
            />
          </div>
        )}
        {openTeamModal && (
          <AddUserModal
            isModalOpen={openTeamModal}
            justCloseIt={() => setOpenTeamModal(false)}
            userActiveLocation={SSO}
          />
        )}
      </div>
    </>
  );
};

export default Chat;
